// @flow

// Vendors
import React from 'react';
import classnames from 'classnames';

type FormSubmitType = {
  label: string,
  disabled: boolean,
  disabledLabel: string,
  className?: string
};

const FormSubmit = ({
  label = 'Submit',
  disabledLabel = 'Submitting...',
  disabled,
  className,
  ...props
}: FormSubmitType) => (
  <div className={classnames('form__field', className)}>
    <div className="form__submit">
      <button type="submit" className="btn btn-primary" disabled={disabled}>
        {disabled ? disabledLabel : label}
      </button>
    </div>
  </div>
);

export default FormSubmit;
